import Axios from 'axios'

export const signInUserRequest = async (username, password) => {
  const response = await Axios.post('/usuarios/login', {
    username,
    password,
  })
  return response.data
}

export const signOutUserRequest = async () => {
  const response = await Axios.post('/usuarios/logout')
  return response.data
}

export const impersonateUserRequest = async (userId) => {
  const response = await Axios.post(`/usuarios/impersonate/${userId}`)
  return response.data
}

export const getCurrentUser = async () => {
  const response = await Axios.get('/usuarios/me')
  return response.data
}
